import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setSystemTheme } from '../redux/slices/themeSlice';

/**
 * Hook to listen for system theme changes and update Redux store accordingly
 * Only updates if no user preference is saved in localStorage
 */
export const useSystemTheme = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Only set up listener if we're in the browser
    if (typeof window === 'undefined' || !window.matchMedia) {
      return;
    }

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const handleChange = (e) => {
      const newTheme = e.matches ? 'dark' : 'light';
      dispatch(setSystemTheme(newTheme));
    };

    // Listen for changes
    mediaQuery.addEventListener('change', handleChange);

    // Cleanup listener on unmount
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [dispatch]);
};
